import { cn } from "@/lib/utils";
import { label, toneOf, TONE_DOT } from "@/lib/labels";
import { AlertTriangle } from "lucide-react";

/**
 * Status as a coloured dot + plain text (default) or a quiet pill (`variant="pill"`).
 * Colour carries meaning only; text stays neutral so tables read calmly.
 */
export const StatusBadge = ({ status, className, entity = "status", warn = false, variant = "dot" }) => {
  if (!status) return null;
  const dot = TONE_DOT[toneOf(status)] || TONE_DOT.neutral;
  if (variant === "pill") {
    return (
      <span data-testid={`status-badge-${entity}-${status}`} className={cn("inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-muted px-1.5 py-0.5 text-[11.5px] font-medium leading-4 text-foreground/80", className)}>
        <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", dot)} aria-hidden />
        {label(status)}
      </span>
    );
  }
  return (
    <span data-testid={`status-badge-${entity}-${status}`} className={cn("inline-flex items-center gap-1.5 whitespace-nowrap text-[12.5px] leading-5 text-foreground/85", className)}>
      {warn ? <AlertTriangle className="h-3 w-3 text-amber-600" /> : <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", dot)} aria-hidden />}
      {label(status)}
    </span>
  );
};
